<template>
    <v-app id="inspire">
        <!-- Aside -->
        <VerticalMenuView :drawer="$root.drawer" :menu="menu"></VerticalMenuView>

        <!-- Header -->
        <HeaderView :drawer="drawer" :notifications="notifications"></HeaderView>

        <!-- Body -->
        <BodyView></BodyView>
        <!-- Footer -->
        <!-- <Footer></Footer> -->
    </v-app>
</template>

<script>
    export default {
        components: {
            VerticalMenuView: () => import('./structure/VerticalMenuView.vue'),
            HeaderView:() => import('./structure/HeaderView.vue'),
            BodyView:() => import('./structure/BodyView.vue'),
            Footer: () => import('./structure/FooterView.vue')
        },
        props: {
            source: String,
        },

        data: () => ({
            drawer: true,
            menu:[],
        }),
        created(){
            this.menu = [];
            // var menuFake = require('@/assets/data/menuFake.json');
            this.$root.obUsuario = _.mapKeys(JSON.parse(localStorage.getItem('informacion')),(v,k) => { return _.camelCase(k) });
            this.menu = JSON.parse(localStorage.getItem('menu'));
            this.isCliente = _.size(_.get(this.$root.obUsuario,'idCliente',null)) > 0 ? true : false;
            if(this.isCliente)
                this.onList('L');
        },
        computed:{
            notifications(){
                return _.get(this.$root,'notifications',{});
            }
        },
        methods:{
            onList(ev) {
                if (!_.isUndefined(ev)) {
                    var error = 'E';
                    var o = {
                            opcion: 'LISTAR',
                            idCliente: _.get(this.$root, ['obUsuario', 'idCliente'], null),
                            estadoNotificacion:'N'
                    }

                    this.$root.notifications.data = [];
                    this.$root.notifications.messages = 0;

                    axios.post(`${BASE_URI}administrador/notificacion/listar`, o)
                            .then((r) => {
                                if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                        var l = _.orderBy(r.data.data,['fechaNotificacion','idNotificacion'],['desc','desc']);
                                        this.$root.notifications.data = l;
                                        this.$root.notifications.messages = _.size(l);
                                        setTimeout(() => {
                                            this.watchSocket();                                            
                                        }, 3000);
                            })
                            .catch((ex) => {
                                mensajesAlerta(ex, error);
                            });
                }
            },
            watchSocket(){
                var id = _.toNumber(_.get(this.$root, ['obUsuario', 'idCliente'], null));

                // URL_SOCKET ya es la URL completa (con esquema ws:// o wss://
                // segun corresponda), armada en main.js - no anteponer otro
                // esquema aqui o queda "ws://wss://..." (URL invalida).
                var ws = new WebSocket(`${URL_SOCKET}?user=${id}`);
                ws.onmessage = (evt) =>{ 
                    var l = this.$root.notifications.messages;
                    var d = _.get(evt,'data','{}');
                    d = _.size(d) == 0 ? '{}' : d;
                    var data = JSON.parse(d);
                    
                    if(_.size(_.get(data,['data'],[])) > 0){
                        l = [];
                        _.forEach(data.data,(v)=>{
                            if(_.isObject(v) && _.has(v,'idNotificacion'))
                                l.push(v);
                        });

                        this.$root.notifications.messages   = _.size(l);
                        this.$root.notifications.data       = _.orderBy(l,['fechaNotificacion','idNotificacion'],['desc','desc']);
                    }
                };
                
                ws.onopen =  (event) =>{ 
                    var o = {
                                user:_.toNumber(_.get(this.$root, ['obUsuario', 'idCliente'], null)),
                                data:{}
                            }
                    ws.send(JSON.stringify(o)); 
                }
            }
        }
    }
</script>